import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Design's rocket for the account-switch transition, exported from Figma.
 *
 * The rocket ONLY. The pale circle behind it belongs to whoever places this,
 * because design's animation moves the rocket and leaves the circle still: baked
 * in here, the background would bob along with it.
 *
 * The export's drop shadows are dropped with the circle they were composed
 * against; what is lost is a 25% blue shadow under the fins and the body.
 */
export function RocketIllustration(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='52 28 96 136'
      fill='none'
    >
      <path
        d='M54.2493 159.325C56.3457 135.48 58.0747 121.175 66.0798 103.805C66.5066 102.878 67.8694 103.139 67.9582 104.155C69.0461 116.6 71.0581 124.446 77.1488 136.795C77.3346 137.172 77.2696 137.629 76.9807 137.934L55.9695 160.103C55.3184 160.791 54.1664 160.268 54.2493 159.325Z'
        fill='#1F477D'
      />
      <path
        d='M145.751 159.325C143.654 135.48 141.925 121.175 133.92 103.805C133.493 102.878 132.131 103.139 132.042 104.155C130.954 116.6 128.942 124.446 122.851 136.795C122.665 137.172 122.73 137.629 123.019 137.934L144.03 160.103C144.682 160.791 145.834 160.268 145.751 159.325Z'
        fill='#1F477D'
      />
      <path
        d='M119.028 148.881C104.673 151.336 96.62 151.493 82.2652 148.881C72.9188 129.588 66.8325 119.264 66.9319 98.8163C67.0776 68.8423 78.7295 52.2945 100.739 29.9087C121.79 53.026 132.469 69.1251 132.884 98.8163C133.167 119.101 128.614 129.232 119.028 148.881Z'
        fill='#3E8FFA'
      />
      <path
        d='M111.824 42.6793C102.88 44.8443 97.8644 44.8844 88.916 42.6793L100.745 28.8L111.824 42.6793Z'
        fill='#C5DCFB'
      />
      <ellipse
        cx='99.8153'
        cy='73.3217'
        rx='11.6386'
        ry='11.6386'
        fill='#F0F5FF'
      />
      <path
        d='M124.386 137.796C105.773 140.498 95.3371 140.373 76.7236 137.796L82.4505 149.065C96.4769 151.545 104.458 151.842 119.029 149.065L124.386 137.796Z'
        fill='#C5DCFB'
      />
      <path
        d='M101.471 124.221C105.76 137.411 105.399 146.584 101.575 161.349C101.315 162.352 99.9126 162.323 99.6922 161.311C96.2621 145.563 95.9005 136.284 99.6641 124.227C99.9451 123.327 101.179 123.324 101.471 124.221Z'
        fill='#1F477D'
      />
    </SvgIcon>
  );
}
